import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEffect, useState } from 'react';
import { IntlProvider as ReactIntlProvider } from 'react-intl';
import { DEFAULT_LOCALE } from './constants';
import { defaultTranslation } from './sources';
import { useLocale, TranslationStatusContextProvider } from './hooks';
import { loadTranslations } from './helpers/loadTranslations';
import { getTranslationsFileName } from './helpers/getTranslationsFileName';
const emptyFunc = () => {
    // do nothing
};
/**
 * IntlProvider component that wraps the ReactIntlProvider to handle
 * translation imports, locale changes, and provides an optional
 * custom translation import function.
 *
 * @param {string} props.locale - The locale for which to load the translation file.
 * @param {ReactNode} props.children - The child components to be wrapped by the IntlProvider.
 * @param {boolean} [props.suppressWarnings=false] - An optional flag to suppress warnings from the ReactIntlProvider. If set to true, warnings will be suppressed; otherwise, they will be displayed.
 * @returns {JSX.Element} - The rendered IntlProvider component.
 */
export const IntlProvider = ({ children, suppressWarnings = false, }) => {
    const [messages, setMessages] = useState(defaultTranslation);
    const [loadedLocale, setLoadedLocale] = useState(DEFAULT_LOCALE);
    const { locale } = useLocale();
    useEffect(() => {
        if (getTranslationsFileName(locale) === DEFAULT_LOCALE) {
            setMessages(defaultTranslation);
            setLoadedLocale(DEFAULT_LOCALE);
            return;
        }
        const updateMessages = async () => {
            const { messages: loadedTranslations, loadedLocale } = await loadTranslations(locale);
            setMessages(loadedTranslations);
            setLoadedLocale(loadedLocale);
        };
        void updateMessages();
    }, [locale]);
    return (_jsx(TranslationStatusContextProvider, { value: { loadedLocale }, children: _jsx(ReactIntlProvider, { locale: locale, messages: messages, onError: suppressWarnings ? emptyFunc : undefined, children: children }) }));
};
//# sourceMappingURL=intlProvider.js.map